import React from "react";

function DataCell({cell, bookingProcessController, planningProcessController, setBookingModalId, setPlanningModalId }) {
  return (
    <>
      {cell.render("Cell")}
      {<div className="icn-wrap">
        <div>
          {bookingProcessController(cell.row.original, cell.row.subRows,cell) && cell.row.original.Container_Count !== "" && (
            <i
              className={cell.column.Header!=="HOLD"?"fi fi-rr-edit-alt tbl-micn":null}
              onClick={() =>
                setBookingModalId(
                  `${cell.row.id}`
                )
              }
            ></i>
          )}
          {/* {planningProcessController(cell.row.original, cell.row.subRows) && cell.row.original.Container_Count !== "" && (
            <i
              className="fi fi-rr-bookmark tbl-micn"
              onClick={() =>
                {
                  setPlanningModalId(
                  `${cell.row.id}`
                )}
              }
            ></i>
          )} */}
        </div>
      </div>}
    </>
  );
}

export default DataCell;
